'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('html-source', {
      url: '/create/html',
      template: '<html-source></html-source>'
    });
}



// WEBPACK FOOTER //
// ./client/app/create/html-source/html-source.routes.ts